import { Component, OnInit } from '@angular/core';
import { ReferencesService } from '../references/references.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-design',
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.scss']
})
export class DesignComponent implements OnInit {
  public references;

  constructor(
    private http: HttpClient,
    private referencesService: ReferencesService
  ) { }

  ngOnInit() {
    this.getReferences();

  }

  getReferences() {
    this.referencesService.getReferences().subscribe(
      data => { this.references = data},
      err => console.error(err)
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/design/design.component.ts